import { map, finalize } from 'rxjs/operators';
import { Component, OnInit, EventEmitter, Input, ViewChild } from '@angular/core';
import { UserService } from '@app/origami-api/services/user.service';
import { ErrorCode } from '@app/origami-api/constants';
import { getServerConfig } from '@app/origami-api/server-config';
import { QuestionAnswer, Question } from '@app/shared/controls/form-controls';
import { UntypedFormControl } from '@angular/forms';
import { SessionService } from '@app/session/session.service';
import { NotificationsService } from '@app/services';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LocalStorageKeys } from '@app/services/local-storage.service';

@Component({
  standalone: false,
  selector: 'ti-password-recovery-setup',
  templateUrl: './password-recovery-setup.component.html',
  styleUrls: ['./password-recovery-setup.component.sass'],
})
export class PasswordRecoverySetupComponent implements OnInit {
  @Input() questionsCount: number;

  readonly localStorageKeys = LocalStorageKeys;

  strings = tiStrings.auth.passwordRecovery;
  strings2 = tiStrings.tiComponents.groupsAndUsers.userPreferences.secretQuestions;
  miscStrings = tiStrings.app.misc;

  private serverConfig = getServerConfig();
  questionsList: Question[];
  answeredList: QuestionAnswer[];

  close$ = new EventEmitter();

  firstSubmit = true;

  fullScreen = false;

  readonly QUESTIONS_ANSWERS_FIELD = 'questionsAnswers';

  @ViewChild('questionsAnswers') questionsAnswers: UntypedFormControl;

  constructor(
    private readonly userService: UserService,
    private readonly session: SessionService,
    private readonly notificationService: NotificationsService,
    private readonly deviceDetectorService: DeviceDetectorService,
  ) {}

  ngOnInit() {
    this.fullScreen = this.deviceDetectorService.isMobile();

    this.getQuestionsAnswers().subscribe((res) => {
      this.questionsList = res.map((x) => ({
        questionId: x.QuestionId,
        question: x.Question,
      }));

      this.answeredList = res
        .filter((x) => x.Answer)
        .map((x) => ({
          questionId: x.QuestionId,
          question: x.Question,
          answer: x.Answer,
        }));
    });
  }

  getQuestionsAnswers() {
    return this.userService
      .getResetPasswordQuestionsAnswers(
        {
          domainName: this.serverConfig.domain,
          userName: null,
        },
        [ErrorCode.RESET_PASSWORD_IS_OFF_FOR_DOMAIN],
      )
      .pipe(map((res) => (res.ErrorCode === ErrorCode.SUCCESS ? res.Result : [])));
  }

  close() {
    this.close$.emit();
  }

  save() {
    if (this.firstSubmit) {
      this.firstSubmit = false;
    }

    if (this.questionsAnswers.invalid) {
      return;
    }

    this.userService
      .setResetPasswordAnswers({
        siteId: this.session.domain.id,
        questionsAnswers: this.questionsAnswers.value.map((item) => ({
          QuestionId: item.questionId,
          Question: item.question,
          Answer: item.answer,
        })),
      })
      .pipe(finalize(() => this.close$.emit()))
      .subscribe((res) => {
        if (res.Success) {
          this.session.user.details.AdditionalInfo.PasswordResetAnswersCount = res.Result;
          this.notificationService.showSuccess(this.strings2.settingsHaveBeenSaved, this.strings2.secretQuestions);
        }
      });
  }
}
